module.exports = __webpack_public_path__ + "img/title-2.8c0ec623.png";